import { delimitWithCommas } from '@javascript/lib/utils';
import classNames from 'classnames';

const InstantSearchLoadMore = ({
  isLoading,
  showMore,
  totalVehicles,
  visibleVehicles,
}: {
  isLoading: boolean;
  showMore: VoidFunction;
  totalVehicles: number | undefined;
  visibleVehicles: number;
}) => {
  if (totalVehicles === undefined) return null;

  const progressPercentage =
    visibleVehicles >= totalVehicles
      ? 100
      : Math.round((visibleVehicles / (totalVehicles || 1)) * 100);

  const showProgress =
    visibleVehicles < totalVehicles &&
    totalVehicles !== 0 &&
    totalVehicles > 24;

  return (
    <nav
      aria-label="Search results navigation"
      className="ch-pagination ch-mt--3 sm:ch-mt--4"
    >
      <p className="ch-pagination__title ch-mb--3 ch-fs--3">
        Showing <strong>{visibleVehicles}</strong> of{' '}
        <strong>{delimitWithCommas(totalVehicles)}</strong> results
      </p>
      {showProgress && (
        <>
          <div className="ch-progress ch-mb--3">
            <div
              className="ch-progress__bar"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>

          <button
            className={classNames(
              'ch-btn ch-btn--primary ch-mb--10',
              isLoading && 'ch-btn--loading',
              'ac__btn--new-focus'
            )}
            onClick={showMore}
            type="button"
          >
            Load more
          </button>
        </>
      )}
    </nav>
  );
};

export default InstantSearchLoadMore;
